import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ig-layout',
  templateUrl: './ig-layout.component.html',
  styleUrls: ['./ig-layout.component.css']
})
export class IgLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
